// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../src/assets/images/contact_landing_one.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../src/assets/images/about_banner_two.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans|Roboto:400,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300i,400,400i,600,600i,700,700i,800,800i|Quicksand:300,400,500,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
=============== 
Fonts
===============
*/

/*
=============== 
Variables
===============
*/

:root {
  /* dark shades of primary color*/
  --clr-primary-1: hsl(184, 91%, 17%);
  --clr-primary-2: hsl(185, 84%, 25%);
  --clr-primary-3: hsl(185, 81%, 29%);
  --clr-primary-4: hsl(184, 77%, 34%);
  /* primary/main color */
  --clr-primary-5: hsl(185, 62%, 45%);
  /* lighter shades of primary color */
  --clr-primary-6: hsl(185, 57%, 50%);
  --clr-primary-7: hsl(184, 65%, 59%);
  --clr-primary-8: hsl(184, 80%, 74%);
  --clr-primary-9: hsl(185, 94%, 87%);
  --clr-primary-10: hsl(186, 100%, 94%);
  /* darkest grey - used for headings */
  --clr-grey-1: hsl(209, 61%, 16%);
  --clr-grey-2: hsl(211, 39%, 23%);
  --clr-grey-3: hsl(209, 34%, 30%);
  --clr-grey-4: hsl(209, 28%, 39%);
  /* grey used for paragraphs */
  --clr-grey-5: hsl(210, 22%, 49%);
  --clr-grey-6: hsl(209, 23%, 60%);
  --clr-grey-7: hsl(211, 27%, 70%);
  --clr-grey-8: hsl(210, 31%, 80%);
  --clr-grey-9: hsl(212, 33%, 89%);
  --clr-grey-10: hsl(210, 36%, 96%);
  --clr-white: #fff;
  --ff-primary: "Roboto", sans-serif;
  --ff-secondary: "Open Sans", sans-serif;
  --transition: all 0.3s linear;
  --spacing: 0.25rem;
  --radius: 0.5rem;
  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  --max-width: 1170px;
  /* dark mode setup */
  --dark-mode-bg-color: #333;
  --dark-mode-text-color: #f0f0f0;
  --backgroundColor: var(--grey-50);
  --textColor: var(--grey-900);
  --darkModeTransition: color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
    /* rest of the colors */
  --black: #222;
  --white: #fff;
  --red-light: #f8d7da;
  --red-dark: #842029;
  --green-light: #d1e7dd;
  --green-dark: #0f5132;
  --blue-light :#0CAFFF;
  --blue-dark :  #004E8C
  --small-text: 0.875rem;
  --extra-small-text: 0.7em;

   /* grey */
   --grey-50: #f8fafc;
   --grey-100: #f1f5f9;
   --grey-200: #e2e8f0;
   --grey-300: #cbd5e1;
   --grey-400: #94a3b8;
   --grey-500: #64748b;
   --grey-600: #475569;
   --grey-700: #334155;
   --grey-800: #1e293b;
   --grey-900: #0f172a;
   /* rest of the colors */
   --black: #222;
   --white: #fff;
   --red-light: #f8d7da;
   --red-dark: #842029;
   --green-light: #d1e7dd;
   --green-dark: #0f5132;
   --small-text: 0.875rem;
   --extra-small-text: 0.7em;
  /* rest of the vars */
  --backgroundColor: var(--grey-50);
  --textColor: var(--grey-900);
  --borderRadius: 0.25rem;
  --letterSpacing: 1px;
  --transition: 0.3s ease-in-out all;
  --max-width: 1120px;
  --fixed-width: 600px;
  --clr-background: #f4f4f4;
  --clr-white: #ffffff;
  --clr-gray-1: #333333;
  --clr-gray-2: #555555;
  --clr-gray-3: #777777;
  --clr-accent: var(--clr-primary-5);

  /* box shadow*/
  --shadow-1: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-2: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-3: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-4: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}


.dark-theme {
  --textColor: var(--dark-mode-text-color);
  --backgroundColor: var(--dark-mode-bg-color);
}

[data-theme = "dark"]{
  /* dark shades of primary color*/
  --clr-primary-1: hsl(240, 4%, 16%) ;
  --clr-primary-2: hsl(0, 0%, 20%);
  --clr-primary-3: hsl(240, 5%, 31%) ;
  --clr-primary-4: hsl(240, 4%, 35%);
 
  /* primary/main color */
  --clr-primary-5: hsl(204, 19%, 26%);
  /* lighter shades of primary color */
  --clr-primary-6: hsl(204, 19%, 26%);
  --clr-primary-7: hsl(204, 19%, 26%);
  --clr-primary-8: hsl(204, 19%, 26%);
  --clr-primary-9: hsl(204, 19%, 26%);
  --clr-primary-10: hsl(204, 19%, 26%);
  /* darkest grey - used for headings */
  --clr-grey-1:  hsl(209, 61%, 16%);
  --clr-grey-2: hsl(211, 39%, 23%);
  --clr-grey-3: hsl(209, 34%, 30%);
  --clr-grey-4: hsl(209, 28%, 39%);
  /* grey used for paragraphs */
  --clr-grey-5: hsl(210, 22%, 49%);
  --clr-grey-6: hsl(209, 23%, 60%);
  --clr-grey-7: hsl(211, 27%, 70%);
  --clr-grey-8: hsl(210, 31%, 80%);
  --clr-grey-9: hsl(212, 33%, 89%);
  --clr-grey-10: hsl(210, 36%, 96%);
  --clr-white: #fff;
  --ff-primary: "Roboto", sans-serif;
  --ff-secondary: "Open Sans", sans-serif;
  --transition: all 0.3s linear;
  --spacing: 0.25rem;
  --radius: 0.5rem;
  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  --max-width: 1170px;
}

/*
=============== 
Global Styles
===============
*/

*,
::after,
::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: var(--ff-secondary);
  background: var(--clr-white);
  color: var(--clr-grey-1);
  line-height: 1.5;
  font-size: 0.875rem;
}

/* body {
  background: var(--backgroundColor);
  color: var(--textColor);
  transition: var(--darkModeTransition);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  line-height: 1;
} */
ul {
  list-style-type: none;
}
a {
  text-decoration: none;
}
/* img:not(.nav-logo) {
  width: 100%;
  display: block;
} */

h1,
h2,
h3,
h4 {
  letter-spacing: var(--spacing);
  text-transform: capitalize;
  line-height: 1.25;
  margin-bottom: 0.75rem;
  font-family: var(--ff-primary);
  font-weight: 400;
  
 
}
h1 {
  font-size: 3rem;
}
h2 {
  font-size: 2rem;
}
h3 {
  font-size: 1.25rem;
}
h4 {
  font-size: 0.875rem;
}
p {
  margin-bottom: 1.25rem;
  color: var(--clr-grey-5);
}
@media screen and (min-width: 800px) {
  h1 {
    font-size: 4rem;
  }
  h2 {
    font-size: 2.5rem;
  }
  h3 {
    font-size: 1.75rem;
  }
  h4 {
    font-size: 1rem;
  }
  body {
    font-size: 1rem;
  }
  h1,
  h2,
  h3,
  h4 {
    line-height: 1;
  }
}
/*  global classes */

.btn {
  text-transform: uppercase;
  background: var(--clr-primary-5);
  color: var(--clr-primary-1);
  padding: 0.375rem 0.75rem;
  letter-spacing: var(--spacing);
  display: inline-block;
  font-weight: 700;
  transition: var(--transition);
  font-size: 0.875rem;
  border: 2px solid transparent;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: var(--radius);
}
.btn:hover {
  color: var(--clr-primary-1);
  background: var(--clr-grey-9);
}

.btn-primary:disabled {
  background-color: var(--clr-grey-5);
  color: #fff; /* Keep text visible */
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

/* section */
.section {
  padding: 5rem 0;
}

.section-title {
  text-align: center;
  margin-bottom: 4rem;
}
.section-title h2 {
  text-transform: uppercase;
}
.section-title span {
  color: var(--clr-primary-5);
}

.section-center {
  width: 90vw;
  margin: 0 auto;
  max-width: 1170px;
}
.section-center-2 {
  width: 90vw;
  margin: 0 auto;
  max-width: 1500px;
}
@media screen and (min-width: 992px) {
  .section-center {
    width: 95vw;
  }
}
/* added during recording */
.underline {
  width: 5rem;
  height: 0.25rem;
  margin-bottom: 1.25rem;
  background: var(--clr-primary-5);
  margin-left: auto;
  margin-right: auto;
}
.section-title {
  margin-bottom: 4rem;
  text-align: center;
}
.bg-grey {
  background: var(--clr-grey-10);
}

/*
=============== 
Header
===============
*/
.custom-logo-container-branded {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 18px; 
  background: var(--clr-grey-10);
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  transition: all 0.3s ease-in-out;
}

/* Add hover effect for subtle animation */
.custom-logo-container-branded:hover {
  transform: translateY(-2px); 
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); 
}

/* Clinic logo */
.custom-clinic-logo {
  height: 55px; 
  width: auto;
  max-width: 130px; 
  object-fit: contain;
  border-radius: 5px; 
  transition: transform 0.3s ease-in-out;
}

/* Logo hover effect */
.custom-clinic-logo:hover {
  transform: scale(1.05); 
}

/* Clinic name & tagline container */
.clinic-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  color: var(--white);
}

/* Clinic name */
.clinic-name-header {
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  /* text-transform: uppercase; */
  color: #2D3748; 
}

/* Clinic tagline */
.clinic-tagline-header {
  font-size: 0.9rem;
  font-style: italic;
  font-weight: 600;
  opacity: 0.85; 
  color: #4A5568; 
}

/* Add hover effect for slight interaction */
.clinic-name-header:hover,
.clinic-tagline-header:hover {
  color: #1A202C; 
}


/* Ensure responsiveness */
@media (max-width: 768px) {
  .custom-logo-container-branded {
    /* flex-direction: column;
    align-items: flex-start; */
    gap: 6px;
  }

  .custom-clinic-logo {
    height: 45px;
    max-width: 100px;
  }

  .clinic-name {
    font-size: 1rem;
  }

  .clinic-tagline {
    font-size: 0.85rem;
  }
}

/* Powered by brand */
.powered-brand {
  font-weight: bold;
  color: var(--clr-primary);
}

.custom-main-header {
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: var(--clr-white); 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); 
  z-index: 1000;
  font-family: var(--ff-primary);
  transition: var(--transition);
  border-bottom: 2px dotted var(--clr-grey-3);
}

.custom-main-header:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


.custom-logo-container-normal {
  display: flex;
  align-items: center;
}

.custom-logo-normal {
  font-size: 2rem;
  font-weight: 700;
  color: var(--clr-white);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: transform 0.3s ease, color 0.3s ease;
}

/* Add hover effect */
.custom-logo-normal:hover {
  color: var(--clr-primary-5);
}

/* Logo Image with Border */
.custom-logo-img {
  width: auto;
  height: auto;
  max-height: 84px;
  border: 2px solid var(--clr-primary-5); 
  border-radius: 8px;                   
  padding: 4px;                         
  background-color: #fff;                
  transition: transform 0.3s ease;
}

.custom-logo-img:hover {
  transform: scale(1.05);
}

/* Text beside the logo */
.custom-logo-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2;
}

.logo-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--clr-primary-4);
}

.logo-tagline {
  font-size: 1rem;
  /* color: var(--clr-grey-1); */
  color: #002D62;
  opacity: 0.8;
}


@media (max-width: 768px) {
  .custom-logo-img {
    width: 90px;
    max-height: 50px;
  }
}

/* Main container for the logo */
.custom-logo-container {
  display: flex;
  flex-direction: column; 
  align-items: center;    
  justify-content: center; 
  padding: 2px;
  
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); 
  text-align: center; 
}


.clinic-brand {
  font-size: 1.5rem;       
  font-weight: bold;       
  color: var(--clr-primary-6);            
}


.powered-by-text {
  font-size: 0.8rem;
  font-weight: 300;
  color: var(--clr-primary-7);
}

.powered-by-brand {
  font-size: 1.2rem;
  font-weight: 700; 
  color: var(--clr-primary-8);
}


.default-logo {
  font-size: 2rem; 
  font-weight: 700; 
  color: var(--clr-white); 
  text-decoration: none;
  transition: transform 0.3s ease, color 0.3s ease;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
  .clinic-name {
    font-size: 1.5rem; 
  }

  .powered-by-text {
    font-size: 0.8rem; 
  }

  .powered-by-brand {
    font-size: 1rem; 
  }

  .custom-logo-container {
    padding: 15px; 
  }
}


.custom-logo-normal:hover {
  color: var(--clr-primary-5); 
  transform: scale(1.05); 
}

.custom-nav-links {
  display: flex;
  align-items: center;
}

.custom-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.custom-links li {
  margin: 0 15px;
  position: relative;
}

.custom-links li a,
.custom-links li span {
  text-decoration: none;
  color: #2D3748; 
  font-weight: 800; 
  font-size: medium;
  padding-bottom: 5px;
  /* border-bottom: 2px solid transparent; */
  cursor: pointer;
  transition: color 0.3s ease;
}

.custom-links li a::after,
.custom-links li span::after {
  content: '';
  position: absolute;
  width: 0%;
  height: 2px;
  left: 0;
  bottom: 0;
  background-color: var(--clr-primary-5); 
  transition: width 0.3s ease-in-out;
}

.custom-links li a:hover::after,
.custom-links li span:hover::after {
  width: 100%;
}

.custom-links li a:hover,
.custom-links li span:hover {
  color: var(--clr-primary-5); 
}

.custom-signup-link {
  color: var(--clr-primary-5); 
}

.custom-hamburger-menu {
  display: none;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.custom-hamburger-icon {
  width: 25px;
  height: 3px;
  background-color: var(--clr-accent); 
  margin: 4px 0;
  transition: all 0.3s ease;
}

.custom-hamburger-menu:hover {
  transform: scale(1.1); 
}

.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(2) {
  opacity: 0;
}

.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.custom-nav-links.open {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 60px;
  right: 20px;
  background-color: var(--clr-grey-10); 
  box-shadow: var(--dark-shadow);
  border-radius: var(--radius);
  padding: 10px;
  z-index: 1001;
}

.custom-nav-links.open .custom-links {
  flex-direction: column;
  align-items: flex-start;
}

.custom-nav-links.open .custom-links li {
  margin: 10px 0;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .custom-nav-links {
      display: none;
  }

  .custom-hamburger-menu {
      display: flex;
  }
}

.disabled-link-header {
  pointer-events: none; 
  opacity: 0.5; 
  cursor: not-allowed; 
}

.active-tab {
  background-color: var(--clr-grey-8); 
  color: white; 
  border-radius: 10px; 
  padding: 5px 10px; 
}

/* .active-tab {
  border-bottom: 3px solid var(--red-light);
  font-weight: bold; 
} */

.language-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px; /* Adds spacing from other elements */
}

.language-selector select {
  padding: 5px 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  cursor: pointer;
}

.language-selector select:focus {
  outline: none;
  border-color: #007bff;
}

/* User Info Container */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Modern Badge for Role */
.user-role-badge {
  font-size: 0.75rem;
  font-weight: 100;
  color: var(--clr-primary-1);
  background: rgba(0, 123, 255, 0.1);
  border: 2px dotted var(--clr-primary-7);
  padding: 2px 6px;
  border-radius: 14px; 
  display: inline-flex;
  align-items: center;
}

/* User Name Styling */
.user-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--blue-light);
}

@media (min-width: 769px) and (max-width: 1024px) {
  .custom-main-header {
    padding: 16px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

    .custom-logo-container-branded,
    .custom-logo-container-normal {
      justify-content: center;
      align-items: center;
      margin: 0 auto; 
      text-align: center;
    }
  

  .custom-nav-links {
    width: 100%;
    justify-content: center;
  }

  .custom-links {
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
  }

  .custom-links li {
    margin: 10px 12px;
  }

  .custom-clinic-logo {
    height: 50px;
    max-width: 120px;
  }

  .clinic-name-header {
    font-size: 1.1rem;
  }

  .clinic-tagline-header {
    font-size: 0.9rem;
  }

  .user-info {
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    gap: 10px;
  }

  .language-selector {
    margin-top: 8px;
    margin-left: 0;
  }
}

.nav-tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.nav-tooltip-text {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background-color: var(--clr-accent);
  color: #fff;
  font-size: 0.75rem;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  transition: opacity 0.2s ease-in-out;
}

/* Centered below */
.nav-tooltip-wrapper.nav-tooltip-bottom .nav-tooltip-text {
  top: 120%;
  left: 50%;
  transform: translateX(-50%);
}

/* Right aligned below (for right-end nav items) */
.nav-tooltip-wrapper.nav-tooltip-bottom-right .nav-tooltip-text {
  top: 120%;
  right: 0;
  left: auto;
}

/* Left aligned below (if needed) */
.nav-tooltip-wrapper.nav-tooltip-bottom-left .nav-tooltip-text {
  top: 120%;
  left: 0;
  right: auto;
}

.nav-tooltip-wrapper:hover .nav-tooltip-text {
  visibility: visible;
  opacity: 1;
}


.features-dropdown {
  position: relative;
  display: inline-block;
}

.features-dropbtn {
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  background: none;
  border: none;
  font-weight: 600;
  transition: color 0.3s ease;
  position: relative;
  white-space: nowrap;
}

.features-dropdown-content {
  display: none;
  position: absolute;
  background-color: var(--clr-grey-8);
  min-width: 180px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 0.4rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.features-dropdown-content a {
  color: var(--clr-white);
  padding: 0.75rem 1rem;
  text-decoration: none;
  display: block;
  transition: background-color 0.3s ease;
}

.features-dropdown-content a:hover {
  background-color: var(--clr-primary-10);
}

/* Show dropdown nicely */
.features-dropdown:hover .features-dropdown-content {
  display: block;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Slight hover color on Features tab */
.features-dropdown:hover .features-dropbtn {
  color: var(--clr-primary-5);
}

.dropdown-caret {
  margin-left: 0.4rem;
  font-size: 0.65rem;
  vertical-align: middle;
}



/*
=============== 
About
===============
*/
/* section title added to globals */
.about-title {
  text-align: left;
  margin-bottom: 2rem;
}
.about-title .underline {
  margin-left: 0;
}
.about-center {
  display: grid;
  gap: 3rem 2rem;
}
.about-img {
  justify-self: center;
}
@media screen and (min-width: 992px) {
  .about-center {
    grid-template-columns: 1fr 1fr;
  }
  .about-img {
    position: relative;
  }
  .about-img::before {
    left: -2rem;
  }
  .about-info {
    align-self: center;
  }
}

/*
=============== 
Services
===============
*/
/* bg-grey in globals */
.service {
  background: var(--clr-white);
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  border-radius: var(--radius);
  text-align: center;
  transition: var(--transition);
}
.service-icon {
  background: var(--clr-primary-5);
  color: var(--clr-primary-1);
  padding: 0.5rem;
  display: inline-block;
  font-size: 2rem;
  margin-bottom: 1.5rem;
}
.service .underline {
  width: 3rem;
  height: 0.12rem;
  transition: var(--transition);
}
.service p {
  transition: var(--transition);
}
.service:hover {
  background: var(--clr-primary-5);
  color: var(--clr-white);
}
.service:hover p {
  color: var(--clr-white);
}
.service:hover .underline {
  background: var(--clr-white);
}
.service-text {
  max-width: 20rem;
  margin-left: auto;
  margin-right: auto;
  text-align: start; /* Aligns text to the left */
  line-height: 1.5; /* Consistent spacing between lines */
  white-space: normal; /* Ensures text wraps properly */
  word-wrap: break-word; /* Prevents long words from overflowing */
}


@media screen and (min-width: 676px) {
  .services-center {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
  }
}
@media screen and (min-width: 992px) {
  .services-center {
    grid-template-columns: 1fr 1fr 1fr;
  }
}


/*
=============== 
Projects
===============
*/
.projects-text {
  width: 85vw;
  max-width: 30rem;
  margin: 0 auto;
}
.project {
  position: relative;
  background: var(--clr-primary-5);
  border-radius: var(--radius);
  margin-bottom: 2rem;
}
.project-info {
  text-align: center;
  color: var(--clr-white);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: var(--transition);
  opacity: 0;
}
.project-info p {
  text-transform: capitalize;
  color: var(--clr-white);
}
.project:hover .project-info {
  opacity: 1;
}
.project-img {
  transition: var(--transition);
  border-radius: var(--radius);
  height: 15rem;
  object-fit: cover;
}
.project:hover .project-img {
  opacity: 0.1;
}
.project::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0.25rem solid var(--clr-white);
  border-radius: var(--radius);
  transition: var(--transition);
  opacity: 0;
}
.project:hover::after {
  opacity: 1;
  transform: scale(0.8);
}
@media screen and (min-width: 676px) {
  .projects-center {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
  }
}
@media screen and (min-width: 992px) {
  .projects-center {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (min-width: 1170px) {
  .projects-center {
    grid-template-rows: 200px 200px;
    gap: 1rem;
    grid-template-areas:
      "a b b"
      "a c d";
  }
  .project-img {
    height: 100%;
  }
  .project {
    height: 100%;
  }
  .project-1 {
    grid-area: a;
  }
  .project-2 {
    grid-area: b;
  }
  .project-3 {
    grid-area: c;
  }
  .project-4 {
    grid-area: d;
  }
}


/*
=============== 
Connect
===============
*/
.connect {
  min-height: 40vh;
  position: relative;
  padding: 10rem 0 5rem 0;
  margin: 5rem 0;
}
.video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}
.connect::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--clr-white);
  /* background: rgba(0, 0, 0, 0.6); */
  opacity: 0.7;
  z-index: -1;
}
.connect {
  display: grid;
  place-items: center;
}
.video-banner .section-title {
  margin-bottom: 2rem;
}
.video-text {
  max-width: 30rem;
}
.video-banner {
  background: var(--clr-primary-10);
  padding: 3rem 5rem 12rem 5rem;
  text-align: center;
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% 75%,
    75% 75%,
    75% 100%,
    50% 75%,
    0% 75%
  );
}
.connect {
  clip-path: polygon(50% 0%, 100% 10%, 100% 90%, 50% 100%, 0 90%, 0 10%);
}



/*
=============== 
Skills
===============
*/
@media screen and (min-width: 768px) {
  .skills-center {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
  }
}
.skills {
  background: var(--clr-primary-9);
}
.skills h3 {
  margin: 1.5rem 0;
  color: var(--clr-primary-1);
}
.skill {
  margin-bottom: 1.25rem;
}
.skill p {
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  color: var(--clr-primary-1);
}
.skill-container {
  background: var(--clr-white);
  height: 1rem;
  width: 100%;
  border-radius: var(--radius);
  position: relative;
}
.skill-value {
  position: absolute;
  top: 0;
  left: 0;
  background: var(--clr-primary-5);
  height: 100%;
  width: 50%;
  border-radius: var(--radius);
}
.value-70 {
  width: 70%;
}
.value-80 {
  width: 80%;
}
.skill-text {
  position: absolute;
  top: -2rem;
  left: 50%;
  transform: translateX(-50%);
}
.skill-text-70 {
  left: 70%;
}
.skill-text-80 {
  left: 80%;
}


/*
=============== 
Timeline - Page
===============
*/
.timeline-center {
  width: 80vw;
  max-width: 40rem;
}
.timeline-item {
  border-top: 2px dashed var(--clr-primary-5);
  margin: 0;
  padding: 4rem 2rem;
  position: relative;
}
.timeline p {
  margin-bottom: 0;
}
.timeline-item:nth-child(even) {
  border-left: 2px dashed var(--clr-primary-5);
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;

  margin-right: 2rem;
  padding-right: 0;
}
.timeline-item:nth-child(odd) {
  border-right: 2px dashed var(--clr-primary-5);
  border-top-right-radius: 2rem;
  border-bottom-right-radius: 2rem;
  margin-left: 2rem;
  padding-left: 0;
}
.timeline-item:first-child {
  border-top: 0;
  border-top-right-radius: 0;
}
.timeline-item:last-child {
  border-bottom-left-radius: 0;
}
.number {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-bottom: 0;
  background: var(--clr-primary-5);
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--clr-primary-1);
  font-weight: bold;
}
.timeline-item:nth-child(even) .number {
  left: 0;
}
.timeline-item:nth-child(odd) .number {
  right: 0;
  transform: translate(50%, -50%);
}


.timeline-container {
  padding: 4rem 2rem;
  background-color: var(--clr-primary-10);
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  max-width: 80rem;
}

.timeline-title {
  font-size: 2.5rem;
  color: var(--clr-primary-4);
  margin-bottom: 3rem;
  font-weight: bold;
}
.custom-intro-card {
  background-color: var(--clr-white);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 1s ease-in-out;
}

.custom-intro-text {
  font-size: 1.25rem;
  color: var(--clr-gray-2);
  line-height: 1.6;
}


/*
=============== 
Blog
===============
*/
.blog {
  background: var(--clr-grey-10);
}
.card {
  height: 27rem;
  position: relative;
  /* talk later */
  perspective: 1500px;
}
.card-main{
  height: 45rem;
  position: relative;
  /* talk later */
  perspective: 1500px;
}
.card-side {
  transition: all 2s linear;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--radius);
  -webkit-transform: translate3d(0, 0, 0);
  visibility: visible;
}
.card-front {
  background: var(--clr-white);
}
.card-main-front{
  background: var(--clr-white);
}
.card-back {
  background: var(--clr-primary-10);
  transform: rotateY(180deg);
  display: grid;
  place-items: center;
}
.card-main-back {
  background: var(--clr-primary-10);
  transform: rotateY(180deg);
  display: grid;
  place-items: center;
}
.card:hover .card-front {
  transform: rotateY(-180deg);
}
.card:hover .card-back {
  transform: rotateY(0);
}
/* rest of the styles */
.card-info {
  padding: 1rem 1.5rem;
}
.card-front img {
  height: 13rem;
  object-fit: cover;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.card-footer {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
}
.card-footer img {
  width: 2rem;
  height: 2rem;
  object-fit: cover;
  border-radius: 50%;
}
.card-footer p {
  margin-bottom: 0;
  text-transform: uppercase;
  justify-self: end;
  color: var(--clr-primary-5);
  font-size: 0.85rem;
}
.blog-center {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 3rem 1rem;
}


/*
=============== 
Single Page
===============
*/
.single-page {
  background: var(--clr-primary-10);
  min-height: calc(100vh - 5rem - 198px);
}
.page-info {
  max-width: 700px;
}
.page-info a {
  text-transform: uppercase;
  color: var(--clr-primary-5);
  transition: var(--transition);
}
.page-info a:hover {
  color: var(--clr-primary-1);
}

/*
=============== 
Products Page
===============
*/
.projects-hero {
  height: 40vh;
  background: var(--clr-primary-10);
  display: grid;
  place-items: center;
}
.projects-hero .section-title {
  margin-bottom: 0;
}
.single-project {
  background: var(--clr-grey-10);
  border-radius: var(--radius);
}
.project-container img {
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.project-container {
  position: relative;
}
.project-icon {
  position: absolute;
  font-size: 1.75rem;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  width: 4rem;
  height: 4rem;
  display: grid;
  place-items: center;
  background: var(--clr-primary-5);
  border-radius: 50%;
  color: var(--clr-primary-1);
  border: 0.375rem solid var(--clr-grey-10);
}
.project-details {
  padding: 2rem 1.5rem;
}
.project-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: var(--clr-primary-5);
}
.project-footer a {
  color: var(--clr-primary-5);
  text-transform: capitalize;
  transition: var(--transition);
  justify-self: end;
}
.project-footer a:hover {
  color: var(--clr-primary-1);
}
.projects-page-center {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 3rem 1rem;
}

/*
=============== 
Gallery
===============
*/
.gallery-img-container {
  position: relative;
  background: var(--clr-primary-5);
}
.gallery-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 2rem;
  transform: translate(-50%, -50%);
  color: var(--clr-white);
  opacity: 0;
  cursor: pointer;
  transition: var(--transition);
}
.gallery-img {
  height: 17rem;
  object-fit: cover;
  transition: var(--transition);
}
.gallery-img-container:hover .gallery-img {
  opacity: 0.5;
}
.gallery-img-container:hover .gallery-icon {
  opacity: 1;
}
@media screen and (min-width: 768px) {
  .gallery-center {
    display: flex;
    flex-wrap: wrap;
  }
  .gallery-img-container {
    flex: 0 0 50%;
  }
}
@media screen and (min-width: 992px) {
  .gallery-img-container {
    flex: 0 0 25%;
  }
}
/*


/*
=============== 
Contact
===============
*/
.contact {
  background: var(--clr-primary-5);
}
.contact-title {
  color: var(--clr-white);
}
.contact-title p {
  color: var(--clr-primary-8);
}
.contact-form {
  display: flex;
  max-width: 28rem;
}
.form-control {
  flex: 1 1 auto;
  color: var(--clr-grey-5);
}
.form-control,
.btn-submit {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 300;
  letter-spacing: var(--spacing);
  background: var(--clr-white);
  text-transform: capitalize;
  border: transparent;
}
.form-control::placeholder {
  color: inherit;
}
.btn-submit {
  font-family: var(--ff-primary);
  margin-left: 0.5rem;
  background: var(--clr-primary-8);
  color: var(--clr-primary-2);
  cursor: pointer;
  transition: var(--transition);
}
.btn-submit:hover {
  background: var(--clr-primary-1);
  color: var(--clr-primary-5);
}
@media screen and (min-width: 992px) {
  .contact-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .contact-form {
    align-self: flex-start;
    flex: 1 1 auto;
    max-width: 100%;
    padding-left: 2rem;
  }
}

.carousel-container {
  background: #f1f1f1;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

.carousel-item {
  height: 20rem;
  min-width: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: cubic-bezier(0.39, 0.575, 0.565, 1);
}



/* form */

.form {
  width: 90vw;
  max-width: var(--fixed-width);
  background: var(--white);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2);
  padding: 2rem 2.5rem;
  margin: 3rem auto;
}
.form-label {
  display: block;
  font-size: var(--small-text);
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  letter-spacing: var(--letterSpacing);
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.375rem 0.75rem;
  border-radius: var(--borderRadius);
  background: var(--backgroundColor);
  border: 1px solid var(--grey-200);
}

.form-row {
  margin-bottom: 1rem;
}

.form-textarea {
  height: 7rem;
}
::placeholder {
  font-family: inherit;
  color: var(--grey-400);
}
.form-alert {
  color: var(--red-dark);
  letter-spacing: var(--letterSpacing);
  text-transform: capitalize;
}
/* extra styles */
.form .form-label {
  text-align: left;
}
.form .btn-block {
  margin-top: 0.5rem;
}

/* Root Colors for Background */
.success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(
    135deg, 
    var(--clr-primary-9) 0%, 
    var(--clr-primary-4) 100%
  );
}

/* Success Card */
.success-card {
  background-color: #ffffff;
  padding: 2.5rem 4rem;
  border-radius: 1rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 37.5rem; /* 600px in rem */
  width: 100%;
  animation: fadeIn 0.6s ease-in-out;
}

/* Success Title */
.success-title {
  font-size: 2.5rem;
  margin-bottom: 1.25rem;
  color: var(--clr-primary-5);
  font-weight: bold;
}

/* Success Message */
.success-message {
  font-size: 1.3rem;
  color: var(--clr-primary-3);
  margin-bottom: 1.25rem;
}

/* Success Redirect Message */
.success-redirect {
  font-size: 1.1rem;
  color: var(--clr-primary-2);
}

/* Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-1.25rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.role-selection-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 2rem;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: hsl(185, 62%, 45%);
}

.role-selection-title {
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: #333;
}

.role-selection-option {
  margin-bottom: 1rem;
  padding: 0.5rem;
}

.role-label {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: #444;
}

.role-input {
  margin-right: 1rem;
  transform: scale(1.2);
  accent-color: #007bff;
}

.role-selection-button {
  display: block;
  width: 100%;
  padding: 0.75rem;
  font-size: 1.1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.role-selection-button:hover {
  background-color: #0056b3;
}


/* Open Modal on the Static Page */


.account-popup-area {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(20, 31, 114, 0.6); */
  background:  hsl(185, 94%, 87%, 0.6);
  opacity: 1;
  z-index: 99;
  overflow-y: scroll;
}
.account-popup-check {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 99;
  margin-top: -300px;
}
.account-popup {
  position: relative;
  float: left;
  width: 460px;
  background: #fff;
  z-index: 1;
  border-radius: 8px;
  left: 50%;
  margin-left: -230px;
  margin-top: 140px;
  margin-bottom: 60px;
  text-align: justify;
  padding: 40px 60px;
}
.account-popup > h3 {
  float: left;
  width: 100%;
  font-family: Quicksand;
  color: #222;
  font-weight: bold;
  margin: 0;
  margin-bottom: 0px;
  margin-bottom: 12px;
  line-height: 10px;
  text-align: center;
}
.account-popup > span {
  float: left;
  width: 100%;
  font-size: 13px;
  font-family: Open Sans;
  font-size: 13px;
  color: #888;
  margin-top: 20px;
}
.account-popup > form {
  float: left;
  width: 100%;
  margin-top: 30px;
}
.account-popup > form .cfield {
  float: left;
  width: 100%;
  position: relative;
  margin-bottom: 19px;
  border: 2px solid #e8ecec;
  border-radius: 8px;
}
.account-popup > form .cfield input {
  float: left;
  width: 100%;
  background: no-repeat;
  margin: 0;
  font-family: Open Sans;
  font-size: 13px;
  color: #474747;
  padding: 16px 45px 16px 15px;
}
.account-popup > form .cfield i {
  position: absolute;
  right: 0;
  top: 15px;
  right: 20px;
  font-size: 19px;
}
.account-popup > form > a {
  float: right;
  font-family: Open Sans;
  font-size: 13px;
  text-decoration: underline;
  line-height: 30px;
}
.account-popup > form button {
  float: left;
  width: 100%;
  height: 60px;
  font-size: 17px;
  font-weight: bold;
  letter-spacing: 0.3px;
  margin-top: 20px;
  border-radius: 8px;
  transition: all 0.4s ease 0s;
}
.account-popup > form button:hover {
  background: hsl(184, 77%, 34%);
}
.account-popup .close-popup {
  position: absolute;
  top: -20px;
  width: 50px;
  height: 50px;
  float: none;
  margin: 0;
  right: -20px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  border-radius: 50%;
  cursor: pointer;
}
.account-popup-register {
  margin-top: 70px;
}

textarea {
	width: 100%;
	padding: 0.375rem 0.75rem;
	border-radius: var(--borderRadius);
	background: var(--backgroundColor);
	border: 1px solid var(--grey-200);
}

/*
=============== 
FAQ's
===============
*/

main {
  min-height: 100vh;
  /* using flex because of better browser support */
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  width: 90vw;
  margin: 5rem auto;
  background: var(--white);
  border-radius: var(--borderRadius);
  padding: 2.5rem;
  max-width: 800px;
  box-shadow: var(--shadow-3);
}
.container h1 {
  text-align: center;
  margin-bottom: 3rem;
  color: var(--grey-700);
}
.question {
  padding: 1rem 1.5rem;
  border: 2px solid var(--grey-200);
  margin-bottom: 1rem;
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-3);
  margin-bottom: 2rem;
}

.question p {
  color: var(--grey-500);
  line-height: 2;
  margin-top: 1rem;
}
.question header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.question h5 {
  font-weight: 500;
  line-height: 1.5;
  color: var(--grey-700);
}
.question-btn {
  background: transparent;
  border-color: transparent;
  width: 2rem;
  height: 2rem;
  background: var(--primary-900);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--white);
  cursor: pointer;
  /* optional - last item */
  align-self: flex-start;
  min-width: 2rem;
}

/*
=============== 
Form and its corresponding components
===============
*/

.form {
  width: 90vw;
  max-width: var(--fixed-width);
  background: var(--white);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2);
  padding: 2rem 2.5rem;
  margin: 3rem auto;
}
.form-label {
  display: block;
  font-size: var(--small-text);
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  letter-spacing: var(--letterSpacing);
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.375rem 0.75rem;
  border-radius: var(--borderRadius);
  background: var(--backgroundColor);
  border: 1px solid var(--grey-200);
}

.form-row {
  margin-bottom: 1rem;
}

.form-textarea {
  height: 7rem;
}
::placeholder {
  font-family: inherit;
  color: var(--grey-400);
}
.form-alert {
  color: var(--red-dark);
  letter-spacing: var(--letterSpacing);
  text-transform: capitalize;
}
/* extra styles */
.form .form-label {
  text-align: left;
}
.form .btn-block {
  margin-top: 0.5rem;
}


/*
=============== 
Contact-Hero
===============
*/

.contact-hero {
  min-height: 80vh;
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
}
/* underline added to globals */
.contact-hero .underline {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.contact-hero-img {
  display: none;
}
/* .hero {
  background: var(--clr-primary-10);
} */

.contact-hero-banner {
  text-align: center;
  color: var(--clr-white);
  /* color: darkblue; */
  padding: 0 3rem;
}
.contact-hero-banner h1 {
  text-transform: uppercase;
}
.contact-hero-banner p {
  max-width: 35rem;
  margin-left: auto;
  margin-right: auto;
  color: var(--clr-white);
  letter-spacing: var(--spacing);
}
.contact-hero-btn {
  padding: 0.9rem 1.6rem;
  font-size: 1.25rem;
  background: var(--clr-white);
  color: var(--clr-primary-5);
}
.contact-hero-btn:hover {
  background: transparent;
  color: var(--clr-white);
  border-color: var(--clr-white);
}
.contact-hero {
  background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
}

@media screen and (min-width: 768px) {
  .contact-hero {
    background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
  }
  .contact-hero-banner {
    padding: 0;
  }
  .contact-hero-banner p {
    max-width: 45rem;
  }
}

@media screen and (min-width: 992px) {
  .contact-hero-img {
    display: block;
    position: relative;
  }
  .contact-hero-center {
    grid-template-columns: 1fr 1fr;
  }

  .contact-hero-img::before,
  .about-img::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0.25rem solid var(--clr-primary-5);
    top: 2rem;
    right: -2rem;
    border-radius: var(--radius);
  }
}


/*
=============== 
About US - New Design
===============
*/


.about-us {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 2rem;
}

/* .about-page {
  padding: 4rem 2rem;
  background-color: var(--clr-primary-9); 
} */

.objectives-section, .disciplines-section, .why-choose-us-section {
  margin-bottom: 4rem;
}

.objectives-container, .disciplines-container, .why-choose-us-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;
  max-width: var(--max-width);
  margin: 0 auto;
}

.objectives-content,.vision-mission-content, .disciplines-content, .why-choose-us-content {
  flex: 1 1;
  max-width: 50%;
  color: var(--clr-grey-1);
}

.objectives-content h2,.vision-mission-content h2, .disciplines-content h2, .why-choose-us-content h2 {
  color: var(--clr-primary-1);
  font-family: var(--ff-primary);
  margin-bottom: 1.5rem;
  font-size: 2.5rem;
}

.objectives-content ul,.vision-mission-content ul, .disciplines-content ul, .why-choose-us-content ul {
  list-style: none;
  padding-left: 0;
}

.objectives-content li,.vision-mission-content li, .disciplines-content li, .why-choose-us-content li {
  margin-bottom: 1.5rem;
  /* font-size: 1.125rem; */
  line-height: 1.6;
  color: var(--clr-grey-2);
}

.objectives-content .objective-title, .vision-mission-content .vision-mission-title, .disciplines-content .discipline-title, .why-choose-us-content .why-title {
  font-weight: bold;
  color: var(--clr-primary-2);
  margin-right: 0.4rem;
}

.objectives-image, .disciplines-image, .why-choose-us-image {
  flex: 1 1;
  max-width: 40%;
}

.objectives-image img, .disciplines-image img, .why-choose-us-image img {
  width: 100%;
  border-radius: var(--radius);
  box-shadow: var(--light-shadow);
}

/* Responsive Design */
@media (max-width: 768px) {
  .objectives-container, .disciplines-container, .why-choose-us-container {
    flex-direction: column;
  }

  .objectives-content, .vision-mission-content, .disciplines-content, .why-choose-us-content,
  .objectives-image, .disciplines-image, .why-choose-us-image {
    max-width: 100%;
  }

  .objectives-content h2,.vision-mission-content h2, .disciplines-content h2, .why-choose-us-content h2 {
    font-size: 2rem;
  }

  .objectives-content li, .vision-mission-content li, .disciplines-content li, .why-choose-us-content li {
    font-size: 1rem;
  }
}
.about-section, .vision-mission-section, .objectives-section, .disciplines-section {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3rem;
}

.about-content, .vision-mission-content, .objectives-content, .disciplines-content {
  flex: 1 1;
  padding: 1rem;
  color: var(--clr-grey-1);
}

.about-image, .vision-mission-image, .objectives-image, .disciplines-image , .why-choose-us-image{
  flex: 1 1;
  padding: 1rem;
  /* background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),
    url('../../../src/assets/images/contact_landing_one.jpeg') center/cover no-repeat; */
}

.about-image img, .vision-mission-image img, .objectives-image img, .disciplines-image img , .why-choose-us-image img{
  width: 100%;
  height: auto;
  border-radius: var(--radius);
  box-shadow: var(--light-shadow);
}

.about-content h2, .vision-mission-content h2, .objectives-content h2, .disciplines-content h2 , .why-choose-us-content h2{
  color: var(--clr-primary-5);
  margin-bottom: 1rem;
  font-family: var(--ff-primary);
}

.about-content p, .vision-mission-content p, .objectives-content p, .disciplines-content p , .why-choose-us-content p{
  color: var(--clr-grey-2);
  font-family: var(--ff-secondary);
}


.about-section .about-content,
.objectives-section .objectives-content

{
  order: 1;
}

.about-section .about-image, 
.objectives-section .objectives-image 

{
  order: 2;
}

.vision-mission-section .vision-mission-content, .disciplines-section .disciplines-content {
  order: 2;
}

.vision-mission-section .vision-mission-image, .disciplines-section .disciplines-image {
  order: 1;
}

/* ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  color: var(--clr-grey-5);
} */

p {
  font-family: var(--ff-secondary);
  line-height: 1.8;
  color: var(--clr-grey-5);
}

@media screen and (max-width: 768px) {
  .about-section, .vision-mission-section, .objectives-section, .disciplines-section {
    flex-direction: column;
  }
}

.vision-mission-image, .objectives-image, .disciplines-image , .why-choose-us-image  {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background-color: var(--clr-primary-10); 
}

.about-main-photo {
  width: 100%;
  max-width: 600px;
  border: 5px solid var(--clr-primary-5);
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  object-fit: cover;
}

.about-main-photo:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);
}


/*
=============== 
About-Hero
===============
*/

.about-hero {
  min-height: 80vh;
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
}
/* underline added to globals */
.about-hero .underline {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.about-hero-img {
  display: none;
}
/* .hero {
  background: var(--clr-primary-10);
} */

.about-hero-banner {
  text-align: center;
  color: var(--clr-white);
  /* color: darkblue; */
  padding: 0 3rem;
}
.about-hero-banner h1 {
  text-transform: uppercase;
}
.about-hero-banner p {
  max-width: 35rem;
  margin-left: auto;
  margin-right: auto;
  color: var(--clr-white);
  letter-spacing: var(--spacing);
}
.about-hero-btn {
  padding: 0.9rem 1.6rem;
  font-size: 1.25rem;
  background: var(--clr-white);
  color: var(--clr-primary-5);
}
.about-hero-btn:hover {
  background: transparent;
  color: var(--clr-white);
  border-color: var(--clr-white);
}
.about-hero {
  background: linear-gradient(rgb(45, 70, 70, 0.7), rgba(0, 0, 0, 0.7)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat
}

@media screen and (min-width: 768px) {
  .about-hero {
    background: linear-gradient(rgb(45, 70, 70, 0.7), rgba(0, 0, 0, 0.7)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat
  }
  .about-hero-banner {
    padding: 0;
  }
  .about-hero-banner p {
    max-width: 60rem;
  }
}

@media screen and (min-width: 992px) {
  .about-hero-img {
    display: block;
    position: relative;
  }
  .about-hero-center {
    grid-template-columns: 1fr 1fr;
  }

  .about-hero-img::before,
  .about-img::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0.25rem solid var(--clr-primary-5);
    top: 2rem;
    right: -2rem;
    border-radius: var(--radius);
  }
}

/*
=============== 
Section Divider line
===============
*/
.section-divider {
  border: none;
  border-top: 2px solid var(--red-dark); /* Light grey line */
  margin: 2rem 0; /* Space around the line */
  opacity: 0.8; /* Slight transparency */
}

/* Optional: You can animate the separator when it comes into view */
@keyframes fadeInLine {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.section-divider {
  animation: fadeInLine 0.6s ease-in-out;
}

`, "",{"version":3,"sources":["webpack://./src/components/css/styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAID;;;;CAIC;;AAED;EACE,gCAAgC;EAChC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,4CAA4C;EAC5C,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,4BAA4B;EAC5B;qCACmC;IACjC,uBAAuB;EACzB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB;wBACsB;EACtB,yBAAyB;;GAExB,SAAS;GACT,kBAAkB;GAClB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,mBAAmB;GACnB,uBAAuB;GACvB,aAAa;GACb,aAAa;GACb,oBAAoB;GACpB,mBAAmB;GACnB,sBAAsB;GACtB,qBAAqB;GACrB,sBAAsB;GACtB,yBAAyB;EAC1B,qBAAqB;EACrB,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;;EAElC,cAAc;EACd,2EAA2E;EAC3E;sCACoC;EACpC;sCACoC;EACpC;wCACsC;EACtC,6CAA6C;EAC7C,4CAA4C;AAC9C;;;AAGA;EACE,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;;EAElC,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;;;CAIC;;AAED;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;GAQG;AACH;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;;GAGG;;AAEH;;;;EAIE,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;;;AAGlB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,cAAc;EAChB;AACF;AACA,oBAAoB;;AAEpB;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAEhB,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,WAAW,EAAE,sBAAsB;EACnC,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;;AAEA;;;;CAIC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;;EAEE,cAAc;AAChB;;;AAGA,0BAA0B;AAC1B;EACE;IACE;8BAC0B;IAC1B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gDAAgD;AAClD;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,YAAY;AACd;;;AAGA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;;EAEZ,wCAAwC;EACxC,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,0CAA0C;AAC1C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,OAAO;EACP,SAAS;EACT,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;MACI,aAAa;EACjB;;EAEA;MACI,aAAa;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;IAEE;;MAEE,uBAAuB;MACvB,mBAAmB;MACnB,cAAc;MACd,kBAAkB;IACpB;;;EAGF;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;;;AAIA;;;;CAIC;AACD,mCAAmC;AACnC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;CAIC;AACD,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAElB,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EAEf,6BAA6B;AAC/B;AACA;EAEE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB,EAAE,qCAAqC;EACvD,mBAAmB,EAAE,gCAAgC;EACrD,qBAAqB,EAAE,yCAAyC;AAClE;;;AAGA;EACE;IACE,aAAa;IACb,8BAA8B;IAG9B,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kCAAkC;EACpC;AACF;;;AAGA;;;;CAIC;AACD;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;EAEhC,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EAEb,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,4BAA4B;EAE5B,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,UAAU;EAEV,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;IACb,8BAA8B;IAG9B,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,SAAS;IACT;;aAES;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;;AAGA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EAEZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAWlB;;;;;;;;GAQC;AACH;AACA;EASE,sEAAsE;AACxE;;;;AAIA;;;;CAIC;AACD;EACE;IACE,aAAa;IACb,8BAA8B;IAG9B,gBAAgB;EAClB;AACF;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EAET,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;;;AAGA;;;;CAIC;AACD;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,+BAA+B;;EAE/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EAER,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;EAER,+BAA+B;AACjC;;;AAGA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;;AAGA;;;;CAIC;AACD;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EAEf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EAEf,mBAAmB;AACrB;AACA;EAEE,yBAAyB;EAEzB,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EAEjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;EAEjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;AACA;EAEE,2BAA2B;AAC7B;AACA;EAEE,qBAAqB;AACvB;AACA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EAEb,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,+BAA+B;EAE/B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;;AAGA;;;;CAIC;AACD;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAE3B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;;AAEA;;;;CAIC;AACD;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EAET,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAE1B,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;;;;CAIC;AACD;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;;;;;;CAOC;AACD;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;;EAEE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;AACjD;;;;AAIA,SAAS;;AAET;EACE,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;AAC5B;AACA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb;;;;GAIC;AACH;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB,EAAE,iBAAiB;EACrC,WAAW;EACX,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,kCAAkC;;;AAGlC;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EAKV,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EAKzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAKhB,kBAAkB;EAKlB,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EAKf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,kCAAkC;CAClC,kCAAkC;CAClC,iCAAiC;AAClC;;AAEA;;;;CAIC;;AAED;EACE,iBAAiB;EACjB,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;EACE,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;AAC5B;AACA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;;AAGA;;;;CAIC;;AAED;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE;kEACmF;AACrF;;AAEA;EACE;IACE;oEACmF;EACrF;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,SAAS;IACT,YAAY;IACZ,4BAA4B;EAC9B;AACF;;;AAGA;;;;CAIC;;;AAGD;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,aAAa;EACb;wFACsF;AACxF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;;AAGA;;;;EAIE,QAAQ;AACV;;AAEA;;;;EAIE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;;;;GAIG;;AAEH;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;;AAGA;;;;CAIC;;AAED;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE;;AAEF;;AAEA;EACE;IACE;;EAEF;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,SAAS;IACT,YAAY;IACZ,4BAA4B;EAC9B;AACF;;AAEA;;;;CAIC;AACD;EACE,YAAY;EACZ,qCAAqC,EAAE,oBAAoB;EAC3D,cAAc,EAAE,0BAA0B;EAC1C,YAAY,EAAE,wBAAwB;AACxC;;AAEA,oEAAoE;AACpE;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* \n=============== \nFonts\n===============\n*/\n@import url(\"https://fonts.googleapis.com/css?family=Open+Sans|Roboto:400,700&display=swap\");\n@import \"https://fonts.googleapis.com/css?family=Open+Sans:300i,400,400i,600,600i,700,700i,800,800i|Quicksand:300,400,500,700\";\n\n/*\n=============== \nVariables\n===============\n*/\n\n:root {\n  /* dark shades of primary color*/\n  --clr-primary-1: hsl(184, 91%, 17%);\n  --clr-primary-2: hsl(185, 84%, 25%);\n  --clr-primary-3: hsl(185, 81%, 29%);\n  --clr-primary-4: hsl(184, 77%, 34%);\n  /* primary/main color */\n  --clr-primary-5: hsl(185, 62%, 45%);\n  /* lighter shades of primary color */\n  --clr-primary-6: hsl(185, 57%, 50%);\n  --clr-primary-7: hsl(184, 65%, 59%);\n  --clr-primary-8: hsl(184, 80%, 74%);\n  --clr-primary-9: hsl(185, 94%, 87%);\n  --clr-primary-10: hsl(186, 100%, 94%);\n  /* darkest grey - used for headings */\n  --clr-grey-1: hsl(209, 61%, 16%);\n  --clr-grey-2: hsl(211, 39%, 23%);\n  --clr-grey-3: hsl(209, 34%, 30%);\n  --clr-grey-4: hsl(209, 28%, 39%);\n  /* grey used for paragraphs */\n  --clr-grey-5: hsl(210, 22%, 49%);\n  --clr-grey-6: hsl(209, 23%, 60%);\n  --clr-grey-7: hsl(211, 27%, 70%);\n  --clr-grey-8: hsl(210, 31%, 80%);\n  --clr-grey-9: hsl(212, 33%, 89%);\n  --clr-grey-10: hsl(210, 36%, 96%);\n  --clr-white: #fff;\n  --ff-primary: \"Roboto\", sans-serif;\n  --ff-secondary: \"Open Sans\", sans-serif;\n  --transition: all 0.3s linear;\n  --spacing: 0.25rem;\n  --radius: 0.5rem;\n  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  --max-width: 1170px;\n  /* dark mode setup */\n  --dark-mode-bg-color: #333;\n  --dark-mode-text-color: #f0f0f0;\n  --backgroundColor: var(--grey-50);\n  --textColor: var(--grey-900);\n  --darkModeTransition: color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n    /* rest of the colors */\n  --black: #222;\n  --white: #fff;\n  --red-light: #f8d7da;\n  --red-dark: #842029;\n  --green-light: #d1e7dd;\n  --green-dark: #0f5132;\n  --blue-light :#0CAFFF;\n  --blue-dark :  #004E8C\n  --small-text: 0.875rem;\n  --extra-small-text: 0.7em;\n\n   /* grey */\n   --grey-50: #f8fafc;\n   --grey-100: #f1f5f9;\n   --grey-200: #e2e8f0;\n   --grey-300: #cbd5e1;\n   --grey-400: #94a3b8;\n   --grey-500: #64748b;\n   --grey-600: #475569;\n   --grey-700: #334155;\n   --grey-800: #1e293b;\n   --grey-900: #0f172a;\n   /* rest of the colors */\n   --black: #222;\n   --white: #fff;\n   --red-light: #f8d7da;\n   --red-dark: #842029;\n   --green-light: #d1e7dd;\n   --green-dark: #0f5132;\n   --small-text: 0.875rem;\n   --extra-small-text: 0.7em;\n  /* rest of the vars */\n  --backgroundColor: var(--grey-50);\n  --textColor: var(--grey-900);\n  --borderRadius: 0.25rem;\n  --letterSpacing: 1px;\n  --transition: 0.3s ease-in-out all;\n  --max-width: 1120px;\n  --fixed-width: 600px;\n  --clr-background: #f4f4f4;\n  --clr-white: #ffffff;\n  --clr-gray-1: #333333;\n  --clr-gray-2: #555555;\n  --clr-gray-3: #777777;\n  --clr-accent: var(--clr-primary-5);\n\n  /* box shadow*/\n  --shadow-1: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --shadow-2: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-3: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-4: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n\n.dark-theme {\n  --textColor: var(--dark-mode-text-color);\n  --backgroundColor: var(--dark-mode-bg-color);\n}\n\n[data-theme = \"dark\"]{\n  /* dark shades of primary color*/\n  --clr-primary-1: hsl(240, 4%, 16%) ;\n  --clr-primary-2: hsl(0, 0%, 20%);\n  --clr-primary-3: hsl(240, 5%, 31%) ;\n  --clr-primary-4: hsl(240, 4%, 35%);\n \n  /* primary/main color */\n  --clr-primary-5: hsl(204, 19%, 26%);\n  /* lighter shades of primary color */\n  --clr-primary-6: hsl(204, 19%, 26%);\n  --clr-primary-7: hsl(204, 19%, 26%);\n  --clr-primary-8: hsl(204, 19%, 26%);\n  --clr-primary-9: hsl(204, 19%, 26%);\n  --clr-primary-10: hsl(204, 19%, 26%);\n  /* darkest grey - used for headings */\n  --clr-grey-1:  hsl(209, 61%, 16%);\n  --clr-grey-2: hsl(211, 39%, 23%);\n  --clr-grey-3: hsl(209, 34%, 30%);\n  --clr-grey-4: hsl(209, 28%, 39%);\n  /* grey used for paragraphs */\n  --clr-grey-5: hsl(210, 22%, 49%);\n  --clr-grey-6: hsl(209, 23%, 60%);\n  --clr-grey-7: hsl(211, 27%, 70%);\n  --clr-grey-8: hsl(210, 31%, 80%);\n  --clr-grey-9: hsl(212, 33%, 89%);\n  --clr-grey-10: hsl(210, 36%, 96%);\n  --clr-white: #fff;\n  --ff-primary: \"Roboto\", sans-serif;\n  --ff-secondary: \"Open Sans\", sans-serif;\n  --transition: all 0.3s linear;\n  --spacing: 0.25rem;\n  --radius: 0.5rem;\n  --light-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  --dark-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  --max-width: 1170px;\n}\n\n/*\n=============== \nGlobal Styles\n===============\n*/\n\n*,\n::after,\n::before {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\nbody {\n  font-family: var(--ff-secondary);\n  background: var(--clr-white);\n  color: var(--clr-grey-1);\n  line-height: 1.5;\n  font-size: 0.875rem;\n}\n\n/* body {\n  background: var(--backgroundColor);\n  color: var(--textColor);\n  transition: var(--darkModeTransition);\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 400;\n  line-height: 1;\n} */\nul {\n  list-style-type: none;\n}\na {\n  text-decoration: none;\n}\n/* img:not(.nav-logo) {\n  width: 100%;\n  display: block;\n} */\n\nh1,\nh2,\nh3,\nh4 {\n  letter-spacing: var(--spacing);\n  text-transform: capitalize;\n  line-height: 1.25;\n  margin-bottom: 0.75rem;\n  font-family: var(--ff-primary);\n  font-weight: 400;\n  \n \n}\nh1 {\n  font-size: 3rem;\n}\nh2 {\n  font-size: 2rem;\n}\nh3 {\n  font-size: 1.25rem;\n}\nh4 {\n  font-size: 0.875rem;\n}\np {\n  margin-bottom: 1.25rem;\n  color: var(--clr-grey-5);\n}\n@media screen and (min-width: 800px) {\n  h1 {\n    font-size: 4rem;\n  }\n  h2 {\n    font-size: 2.5rem;\n  }\n  h3 {\n    font-size: 1.75rem;\n  }\n  h4 {\n    font-size: 1rem;\n  }\n  body {\n    font-size: 1rem;\n  }\n  h1,\n  h2,\n  h3,\n  h4 {\n    line-height: 1;\n  }\n}\n/*  global classes */\n\n.btn {\n  text-transform: uppercase;\n  background: var(--clr-primary-5);\n  color: var(--clr-primary-1);\n  padding: 0.375rem 0.75rem;\n  letter-spacing: var(--spacing);\n  display: inline-block;\n  font-weight: 700;\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n  font-size: 0.875rem;\n  border: 2px solid transparent;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius);\n}\n.btn:hover {\n  color: var(--clr-primary-1);\n  background: var(--clr-grey-9);\n}\n\n.btn-primary:disabled {\n  background-color: var(--clr-grey-5);\n  color: #fff; /* Keep text visible */\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n}\n\n/* section */\n.section {\n  padding: 5rem 0;\n}\n\n.section-title {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n.section-title h2 {\n  text-transform: uppercase;\n}\n.section-title span {\n  color: var(--clr-primary-5);\n}\n\n.section-center {\n  width: 90vw;\n  margin: 0 auto;\n  max-width: 1170px;\n}\n.section-center-2 {\n  width: 90vw;\n  margin: 0 auto;\n  max-width: 1500px;\n}\n@media screen and (min-width: 992px) {\n  .section-center {\n    width: 95vw;\n  }\n}\n/* added during recording */\n.underline {\n  width: 5rem;\n  height: 0.25rem;\n  margin-bottom: 1.25rem;\n  background: var(--clr-primary-5);\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-title {\n  margin-bottom: 4rem;\n  text-align: center;\n}\n.bg-grey {\n  background: var(--clr-grey-10);\n}\n\n/*\n=============== \nHeader\n===============\n*/\n.custom-logo-container-branded {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 18px; \n  background: var(--clr-grey-10);\n  border-radius: 8px; \n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n  transition: all 0.3s ease-in-out;\n}\n\n/* Add hover effect for subtle animation */\n.custom-logo-container-branded:hover {\n  transform: translateY(-2px); \n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); \n}\n\n/* Clinic logo */\n.custom-clinic-logo {\n  height: 55px; \n  width: auto;\n  max-width: 130px; \n  object-fit: contain;\n  border-radius: 5px; \n  transition: transform 0.3s ease-in-out;\n}\n\n/* Logo hover effect */\n.custom-clinic-logo:hover {\n  transform: scale(1.05); \n}\n\n/* Clinic name & tagline container */\n.clinic-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  color: var(--white);\n}\n\n/* Clinic name */\n.clinic-name-header {\n  font-size: 1.2rem;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  /* text-transform: uppercase; */\n  color: #2D3748; \n}\n\n/* Clinic tagline */\n.clinic-tagline-header {\n  font-size: 0.9rem;\n  font-style: italic;\n  font-weight: 600;\n  opacity: 0.85; \n  color: #4A5568; \n}\n\n/* Add hover effect for slight interaction */\n.clinic-name-header:hover,\n.clinic-tagline-header:hover {\n  color: #1A202C; \n}\n\n\n/* Ensure responsiveness */\n@media (max-width: 768px) {\n  .custom-logo-container-branded {\n    /* flex-direction: column;\n    align-items: flex-start; */\n    gap: 6px;\n  }\n\n  .custom-clinic-logo {\n    height: 45px;\n    max-width: 100px;\n  }\n\n  .clinic-name {\n    font-size: 1rem;\n  }\n\n  .clinic-tagline {\n    font-size: 0.85rem;\n  }\n}\n\n/* Powered by brand */\n.powered-brand {\n  font-weight: bold;\n  color: var(--clr-primary);\n}\n\n.custom-main-header {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: var(--clr-white); \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); \n  z-index: 1000;\n  font-family: var(--ff-primary);\n  transition: var(--transition);\n  border-bottom: 2px dotted var(--clr-grey-3);\n}\n\n.custom-main-header:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n\n.custom-logo-container-normal {\n  display: flex;\n  align-items: center;\n}\n\n.custom-logo-normal {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--clr-white);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n/* Add hover effect */\n.custom-logo-normal:hover {\n  color: var(--clr-primary-5);\n}\n\n/* Logo Image with Border */\n.custom-logo-img {\n  width: auto;\n  height: auto;\n  max-height: 84px;\n  border: 2px solid var(--clr-primary-5); \n  border-radius: 8px;                   \n  padding: 4px;                         \n  background-color: #fff;                \n  transition: transform 0.3s ease;\n}\n\n.custom-logo-img:hover {\n  transform: scale(1.05);\n}\n\n/* Text beside the logo */\n.custom-logo-text-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1.2;\n}\n\n.logo-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--clr-primary-4);\n}\n\n.logo-tagline {\n  font-size: 1rem;\n  /* color: var(--clr-grey-1); */\n  color: #002D62;\n  opacity: 0.8;\n}\n\n\n@media (max-width: 768px) {\n  .custom-logo-img {\n    width: 90px;\n    max-height: 50px;\n  }\n}\n\n/* Main container for the logo */\n.custom-logo-container {\n  display: flex;\n  flex-direction: column; \n  align-items: center;    \n  justify-content: center; \n  padding: 2px;\n  \n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); \n  text-align: center; \n}\n\n\n.clinic-brand {\n  font-size: 1.5rem;       \n  font-weight: bold;       \n  color: var(--clr-primary-6);            \n}\n\n\n.powered-by-text {\n  font-size: 0.8rem;\n  font-weight: 300;\n  color: var(--clr-primary-7);\n}\n\n.powered-by-brand {\n  font-size: 1.2rem;\n  font-weight: 700; \n  color: var(--clr-primary-8);\n}\n\n\n.default-logo {\n  font-size: 2rem; \n  font-weight: 700; \n  color: var(--clr-white); \n  text-decoration: none;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 768px) {\n  .clinic-name {\n    font-size: 1.5rem; \n  }\n\n  .powered-by-text {\n    font-size: 0.8rem; \n  }\n\n  .powered-by-brand {\n    font-size: 1rem; \n  }\n\n  .custom-logo-container {\n    padding: 15px; \n  }\n}\n\n\n.custom-logo-normal:hover {\n  color: var(--clr-primary-5); \n  transform: scale(1.05); \n}\n\n.custom-nav-links {\n  display: flex;\n  align-items: center;\n}\n\n.custom-links {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.custom-links li {\n  margin: 0 15px;\n  position: relative;\n}\n\n.custom-links li a,\n.custom-links li span {\n  text-decoration: none;\n  color: #2D3748; \n  font-weight: 800; \n  font-size: medium;\n  padding-bottom: 5px;\n  /* border-bottom: 2px solid transparent; */\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.custom-links li a::after,\n.custom-links li span::after {\n  content: '';\n  position: absolute;\n  width: 0%;\n  height: 2px;\n  left: 0;\n  bottom: 0;\n  background-color: var(--clr-primary-5); \n  transition: width 0.3s ease-in-out;\n}\n\n.custom-links li a:hover::after,\n.custom-links li span:hover::after {\n  width: 100%;\n}\n\n.custom-links li a:hover,\n.custom-links li span:hover {\n  color: var(--clr-primary-5); \n}\n\n.custom-signup-link {\n  color: var(--clr-primary-5); \n}\n\n.custom-hamburger-menu {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.custom-hamburger-icon {\n  width: 25px;\n  height: 3px;\n  background-color: var(--clr-accent); \n  margin: 4px 0;\n  transition: all 0.3s ease;\n}\n\n.custom-hamburger-menu:hover {\n  transform: scale(1.1); \n}\n\n.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(2) {\n  opacity: 0;\n}\n\n.custom-hamburger-menu.open .custom-hamburger-icon:nth-child(3) {\n  transform: rotate(-45deg) translate(5px, -5px);\n}\n\n.custom-nav-links.open {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 60px;\n  right: 20px;\n  background-color: var(--clr-grey-10); \n  box-shadow: var(--dark-shadow);\n  border-radius: var(--radius);\n  padding: 10px;\n  z-index: 1001;\n}\n\n.custom-nav-links.open .custom-links {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.custom-nav-links.open .custom-links li {\n  margin: 10px 0;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .custom-nav-links {\n      display: none;\n  }\n\n  .custom-hamburger-menu {\n      display: flex;\n  }\n}\n\n.disabled-link-header {\n  pointer-events: none; \n  opacity: 0.5; \n  cursor: not-allowed; \n}\n\n.active-tab {\n  background-color: var(--clr-grey-8); \n  color: white; \n  border-radius: 10px; \n  padding: 5px 10px; \n}\n\n/* .active-tab {\n  border-bottom: 3px solid var(--red-light);\n  font-weight: bold; \n} */\n\n.language-selector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 10px; /* Adds spacing from other elements */\n}\n\n.language-selector select {\n  padding: 5px 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.language-selector select:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n/* User Info Container */\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Modern Badge for Role */\n.user-role-badge {\n  font-size: 0.75rem;\n  font-weight: 100;\n  color: var(--clr-primary-1);\n  background: rgba(0, 123, 255, 0.1);\n  border: 2px dotted var(--clr-primary-7);\n  padding: 2px 6px;\n  border-radius: 14px; \n  display: inline-flex;\n  align-items: center;\n}\n\n/* User Name Styling */\n.user-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--blue-light);\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .custom-main-header {\n    padding: 16px 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n    .custom-logo-container-branded,\n    .custom-logo-container-normal {\n      justify-content: center;\n      align-items: center;\n      margin: 0 auto; \n      text-align: center;\n    }\n  \n\n  .custom-nav-links {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .custom-links {\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .custom-links li {\n    margin: 10px 12px;\n  }\n\n  .custom-clinic-logo {\n    height: 50px;\n    max-width: 120px;\n  }\n\n  .clinic-name-header {\n    font-size: 1.1rem;\n  }\n\n  .clinic-tagline-header {\n    font-size: 0.9rem;\n  }\n\n  .user-info {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 10px;\n  }\n\n  .language-selector {\n    margin-top: 8px;\n    margin-left: 0;\n  }\n}\n\n.nav-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.nav-tooltip-text {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  background-color: var(--clr-accent);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 6px 10px;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 1000;\n  transition: opacity 0.2s ease-in-out;\n}\n\n/* Centered below */\n.nav-tooltip-wrapper.nav-tooltip-bottom .nav-tooltip-text {\n  top: 120%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n/* Right aligned below (for right-end nav items) */\n.nav-tooltip-wrapper.nav-tooltip-bottom-right .nav-tooltip-text {\n  top: 120%;\n  right: 0;\n  left: auto;\n}\n\n/* Left aligned below (if needed) */\n.nav-tooltip-wrapper.nav-tooltip-bottom-left .nav-tooltip-text {\n  top: 120%;\n  left: 0;\n  right: auto;\n}\n\n.nav-tooltip-wrapper:hover .nav-tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n\n.features-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.features-dropbtn {\n  cursor: pointer;\n  padding: 0.6rem 1.2rem;\n  background: none;\n  border: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n  position: relative;\n  white-space: nowrap;\n}\n\n.features-dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: var(--clr-grey-8);\n  min-width: 180px;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 0.4rem;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.features-dropdown-content a {\n  color: var(--clr-white);\n  padding: 0.75rem 1rem;\n  text-decoration: none;\n  display: block;\n  transition: background-color 0.3s ease;\n}\n\n.features-dropdown-content a:hover {\n  background-color: var(--clr-primary-10);\n}\n\n/* Show dropdown nicely */\n.features-dropdown:hover .features-dropdown-content {\n  display: block;\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n/* Slight hover color on Features tab */\n.features-dropdown:hover .features-dropbtn {\n  color: var(--clr-primary-5);\n}\n\n.dropdown-caret {\n  margin-left: 0.4rem;\n  font-size: 0.65rem;\n  vertical-align: middle;\n}\n\n\n\n/*\n=============== \nAbout\n===============\n*/\n/* section title added to globals */\n.about-title {\n  text-align: left;\n  margin-bottom: 2rem;\n}\n.about-title .underline {\n  margin-left: 0;\n}\n.about-center {\n  display: grid;\n  gap: 3rem 2rem;\n}\n.about-img {\n  justify-self: center;\n}\n@media screen and (min-width: 992px) {\n  .about-center {\n    grid-template-columns: 1fr 1fr;\n  }\n  .about-img {\n    position: relative;\n  }\n  .about-img::before {\n    left: -2rem;\n  }\n  .about-info {\n    align-self: center;\n  }\n}\n\n/*\n=============== \nServices\n===============\n*/\n/* bg-grey in globals */\n.service {\n  background: var(--clr-white);\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  border-radius: var(--radius);\n  text-align: center;\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n}\n.service-icon {\n  background: var(--clr-primary-5);\n  color: var(--clr-primary-1);\n  padding: 0.5rem;\n  display: inline-block;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n}\n.service .underline {\n  width: 3rem;\n  height: 0.12rem;\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n}\n.service p {\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n}\n.service:hover {\n  background: var(--clr-primary-5);\n  color: var(--clr-white);\n}\n.service:hover p {\n  color: var(--clr-white);\n}\n.service:hover .underline {\n  background: var(--clr-white);\n}\n.service-text {\n  max-width: 20rem;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: start; /* Aligns text to the left */\n  line-height: 1.5; /* Consistent spacing between lines */\n  white-space: normal; /* Ensures text wraps properly */\n  word-wrap: break-word; /* Prevents long words from overflowing */\n}\n\n\n@media screen and (min-width: 676px) {\n  .services-center {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    -webkit-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n}\n@media screen and (min-width: 992px) {\n  .services-center {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n\n/*\n=============== \nProjects\n===============\n*/\n.projects-text {\n  width: 85vw;\n  max-width: 30rem;\n  margin: 0 auto;\n}\n.project {\n  position: relative;\n  background: var(--clr-primary-5);\n  border-radius: var(--radius);\n  margin-bottom: 2rem;\n}\n.project-info {\n  text-align: center;\n  color: var(--clr-white);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n  opacity: 0;\n}\n.project-info p {\n  text-transform: capitalize;\n  color: var(--clr-white);\n}\n.project:hover .project-info {\n  opacity: 1;\n}\n.project-img {\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n  border-radius: var(--radius);\n  height: 15rem;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.project:hover .project-img {\n  opacity: 0.1;\n}\n.project::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0.25rem solid var(--clr-white);\n  border-radius: var(--radius);\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n  opacity: 0;\n}\n.project:hover::after {\n  opacity: 1;\n  -webkit-transform: scale(0.8);\n  transform: scale(0.8);\n}\n@media screen and (min-width: 676px) {\n  .projects-center {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    -webkit-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n}\n@media screen and (min-width: 992px) {\n  .projects-center {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media screen and (min-width: 1170px) {\n  .projects-center {\n    grid-template-rows: 200px 200px;\n    gap: 1rem;\n    grid-template-areas:\n      \"a b b\"\n      \"a c d\";\n  }\n  .project-img {\n    height: 100%;\n  }\n  .project {\n    height: 100%;\n  }\n  .project-1 {\n    grid-area: a;\n  }\n  .project-2 {\n    grid-area: b;\n  }\n  .project-3 {\n    grid-area: c;\n  }\n  .project-4 {\n    grid-area: d;\n  }\n}\n\n\n/*\n=============== \nConnect\n===============\n*/\n.connect {\n  min-height: 40vh;\n  position: relative;\n  padding: 10rem 0 5rem 0;\n  margin: 5rem 0;\n}\n.video-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  z-index: -2;\n}\n.connect::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--clr-white);\n  /* background: rgba(0, 0, 0, 0.6); */\n  opacity: 0.7;\n  z-index: -1;\n}\n.connect {\n  display: grid;\n  place-items: center;\n}\n.video-banner .section-title {\n  margin-bottom: 2rem;\n}\n.video-text {\n  max-width: 30rem;\n}\n.video-banner {\n  background: var(--clr-primary-10);\n  padding: 3rem 5rem 12rem 5rem;\n  text-align: center;\n\n  -webkit-clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% 75%,\n    75% 75%,\n    75% 100%,\n    50% 75%,\n    0% 75%\n  );\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% 75%,\n    75% 75%,\n    75% 100%,\n    50% 75%,\n    0% 75%\n  );\n}\n.connect {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 10%,\n    100% 90%,\n    50% 100%,\n    0 90%,\n    0 10%\n  );\n  clip-path: polygon(50% 0%, 100% 10%, 100% 90%, 50% 100%, 0 90%, 0 10%);\n}\n\n\n\n/*\n=============== \nSkills\n===============\n*/\n@media screen and (min-width: 768px) {\n  .skills-center {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    -webkit-column-gap: 2rem;\n    -moz-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n}\n.skills {\n  background: var(--clr-primary-9);\n}\n.skills h3 {\n  margin: 1.5rem 0;\n  color: var(--clr-primary-1);\n}\n.skill {\n  margin-bottom: 1.25rem;\n}\n.skill p {\n  margin-bottom: 0.5rem;\n  text-transform: capitalize;\n  color: var(--clr-primary-1);\n}\n.skill-container {\n  background: var(--clr-white);\n  height: 1rem;\n  width: 100%;\n  border-radius: var(--radius);\n  position: relative;\n}\n.skill-value {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: var(--clr-primary-5);\n  height: 100%;\n  width: 50%;\n  border-radius: var(--radius);\n}\n.value-70 {\n  width: 70%;\n}\n.value-80 {\n  width: 80%;\n}\n.skill-text {\n  position: absolute;\n  top: -2rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.skill-text-70 {\n  left: 70%;\n}\n.skill-text-80 {\n  left: 80%;\n}\n\n\n/*\n=============== \nTimeline - Page\n===============\n*/\n.timeline-center {\n  width: 80vw;\n  max-width: 40rem;\n}\n.timeline-item {\n  border-top: 2px dashed var(--clr-primary-5);\n  margin: 0;\n  padding: 4rem 2rem;\n  position: relative;\n}\n.timeline p {\n  margin-bottom: 0;\n}\n.timeline-item:nth-child(even) {\n  border-left: 2px dashed var(--clr-primary-5);\n  border-top-left-radius: 2rem;\n  border-bottom-left-radius: 2rem;\n\n  margin-right: 2rem;\n  padding-right: 0;\n}\n.timeline-item:nth-child(odd) {\n  border-right: 2px dashed var(--clr-primary-5);\n  border-top-right-radius: 2rem;\n  border-bottom-right-radius: 2rem;\n  margin-left: 2rem;\n  padding-left: 0;\n}\n.timeline-item:first-child {\n  border-top: 0;\n  border-top-right-radius: 0;\n}\n.timeline-item:last-child {\n  border-bottom-left-radius: 0;\n}\n.number {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  margin-bottom: 0;\n  background: var(--clr-primary-5);\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  color: var(--clr-primary-1);\n  font-weight: bold;\n}\n.timeline-item:nth-child(even) .number {\n  left: 0;\n}\n.timeline-item:nth-child(odd) .number {\n  right: 0;\n  -webkit-transform: translate(50%, -50%);\n  transform: translate(50%, -50%);\n}\n\n\n.timeline-container {\n  padding: 4rem 2rem;\n  background-color: var(--clr-primary-10);\n  text-align: center;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin: 2rem auto;\n  max-width: 80rem;\n}\n\n.timeline-title {\n  font-size: 2.5rem;\n  color: var(--clr-primary-4);\n  margin-bottom: 3rem;\n  font-weight: bold;\n}\n.custom-intro-card {\n  background-color: var(--clr-white);\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 3rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  animation: fadeInUp 1s ease-in-out;\n}\n\n.custom-intro-text {\n  font-size: 1.25rem;\n  color: var(--clr-gray-2);\n  line-height: 1.6;\n}\n\n\n/*\n=============== \nBlog\n===============\n*/\n.blog {\n  background: var(--clr-grey-10);\n}\n.card {\n  height: 27rem;\n  position: relative;\n  /* talk later */\n  -webkit-perspective: 1500px;\n  perspective: 1500px;\n}\n.card-main{\n  height: 45rem;\n  position: relative;\n  /* talk later */\n  -webkit-perspective: 1500px;\n  perspective: 1500px;\n}\n.card-side {\n  -webkit-transition: all 2s linear;\n  transition: all 2s linear;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius);\n  -webkit-transform: translate3d(0, 0, 0);\n  visibility: visible;\n}\n.card-front {\n  background: var(--clr-white);\n}\n.card-main-front{\n  background: var(--clr-white);\n}\n.card-back {\n  background: var(--clr-primary-10);\n  -webkit-transform: rotateY(180deg);\n  transform: rotateY(180deg);\n  display: grid;\n  place-items: center;\n}\n.card-main-back {\n  background: var(--clr-primary-10);\n  -webkit-transform: rotateY(180deg);\n  transform: rotateY(180deg);\n  display: grid;\n  place-items: center;\n}\n.card:hover .card-front {\n  -webkit-transform: rotateY(-180deg);\n  transform: rotateY(-180deg);\n}\n.card:hover .card-back {\n  -webkit-transform: rotateY(0);\n  transform: rotateY(0);\n}\n/* rest of the styles */\n.card-info {\n  padding: 1rem 1.5rem;\n}\n.card-front img {\n  height: 13rem;\n  -o-object-fit: cover;\n  object-fit: cover;\n  border-top-left-radius: var(--radius);\n  border-top-right-radius: var(--radius);\n}\n.card-footer {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  -webkit-box-align: center;\n  align-items: center;\n}\n.card-footer img {\n  width: 2rem;\n  height: 2rem;\n  -o-object-fit: cover;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.card-footer p {\n  margin-bottom: 0;\n  text-transform: uppercase;\n  justify-self: end;\n  color: var(--clr-primary-5);\n  font-size: 0.85rem;\n}\n.blog-center {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));\n  gap: 3rem 1rem;\n}\n\n\n/*\n=============== \nSingle Page\n===============\n*/\n.single-page {\n  background: var(--clr-primary-10);\n  min-height: calc(100vh - 5rem - 198px);\n}\n.page-info {\n  max-width: 700px;\n}\n.page-info a {\n  text-transform: uppercase;\n  color: var(--clr-primary-5);\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n}\n.page-info a:hover {\n  color: var(--clr-primary-1);\n}\n\n/*\n=============== \nProducts Page\n===============\n*/\n.projects-hero {\n  height: 40vh;\n  background: var(--clr-primary-10);\n  display: grid;\n  place-items: center;\n}\n.projects-hero .section-title {\n  margin-bottom: 0;\n}\n.single-project {\n  background: var(--clr-grey-10);\n  border-radius: var(--radius);\n}\n.project-container img {\n  border-top-left-radius: var(--radius);\n  border-top-right-radius: var(--radius);\n}\n.project-container {\n  position: relative;\n}\n.project-icon {\n  position: absolute;\n  font-size: 1.75rem;\n  bottom: 0;\n  left: 50%;\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n  width: 4rem;\n  height: 4rem;\n  display: grid;\n  place-items: center;\n  background: var(--clr-primary-5);\n  border-radius: 50%;\n  color: var(--clr-primary-1);\n  border: 0.375rem solid var(--clr-grey-10);\n}\n.project-details {\n  padding: 2rem 1.5rem;\n}\n.project-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  color: var(--clr-primary-5);\n}\n.project-footer a {\n  color: var(--clr-primary-5);\n  text-transform: capitalize;\n  -webkit-transition: var(--transition);\n  transition: var(--transition);\n  justify-self: end;\n}\n.project-footer a:hover {\n  color: var(--clr-primary-1);\n}\n.projects-page-center {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));\n  gap: 3rem 1rem;\n}\n\n/*\n=============== \nGallery\n===============\n*/\n.gallery-img-container {\n  position: relative;\n  background: var(--clr-primary-5);\n}\n.gallery-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 2rem;\n  transform: translate(-50%, -50%);\n  color: var(--clr-white);\n  opacity: 0;\n  cursor: pointer;\n  transition: var(--transition);\n}\n.gallery-img {\n  height: 17rem;\n  object-fit: cover;\n  transition: var(--transition);\n}\n.gallery-img-container:hover .gallery-img {\n  opacity: 0.5;\n}\n.gallery-img-container:hover .gallery-icon {\n  opacity: 1;\n}\n@media screen and (min-width: 768px) {\n  .gallery-center {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .gallery-img-container {\n    flex: 0 0 50%;\n  }\n}\n@media screen and (min-width: 992px) {\n  .gallery-img-container {\n    flex: 0 0 25%;\n  }\n}\n/*\n\n\n/*\n=============== \nContact\n===============\n*/\n.contact {\n  background: var(--clr-primary-5);\n}\n.contact-title {\n  color: var(--clr-white);\n}\n.contact-title p {\n  color: var(--clr-primary-8);\n}\n.contact-form {\n  display: flex;\n  max-width: 28rem;\n}\n.form-control {\n  flex: 1 1 auto;\n  color: var(--clr-grey-5);\n}\n.form-control,\n.btn-submit {\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  font-weight: 300;\n  letter-spacing: var(--spacing);\n  background: var(--clr-white);\n  text-transform: capitalize;\n  border: transparent;\n}\n.form-control::placeholder {\n  color: inherit;\n}\n.btn-submit {\n  font-family: var(--ff-primary);\n  margin-left: 0.5rem;\n  background: var(--clr-primary-8);\n  color: var(--clr-primary-2);\n  cursor: pointer;\n  transition: var(--transition);\n}\n.btn-submit:hover {\n  background: var(--clr-primary-1);\n  color: var(--clr-primary-5);\n}\n@media screen and (min-width: 992px) {\n  .contact-center {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  .contact-form {\n    align-self: flex-start;\n    flex: 1 1 auto;\n    max-width: 100%;\n    padding-left: 2rem;\n  }\n}\n\n.carousel-container {\n  background: #f1f1f1;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.carousel-item {\n  height: 20rem;\n  min-width: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n\n\n\n/* form */\n\n.form {\n  width: 90vw;\n  max-width: var(--fixed-width);\n  background: var(--white);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2);\n  padding: 2rem 2.5rem;\n  margin: 3rem auto;\n}\n.form-label {\n  display: block;\n  font-size: var(--small-text);\n  margin-bottom: 0.5rem;\n  text-transform: capitalize;\n  letter-spacing: var(--letterSpacing);\n}\n\n.form-input,\n.form-textarea {\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--borderRadius);\n  background: var(--backgroundColor);\n  border: 1px solid var(--grey-200);\n}\n\n.form-row {\n  margin-bottom: 1rem;\n}\n\n.form-textarea {\n  height: 7rem;\n}\n::placeholder {\n  font-family: inherit;\n  color: var(--grey-400);\n}\n.form-alert {\n  color: var(--red-dark);\n  letter-spacing: var(--letterSpacing);\n  text-transform: capitalize;\n}\n/* extra styles */\n.form .form-label {\n  text-align: left;\n}\n.form .btn-block {\n  margin-top: 0.5rem;\n}\n\n/* Root Colors for Background */\n.success-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(\n    135deg, \n    var(--clr-primary-9) 0%, \n    var(--clr-primary-4) 100%\n  );\n}\n\n/* Success Card */\n.success-card {\n  background-color: #ffffff;\n  padding: 2.5rem 4rem;\n  border-radius: 1rem;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.2);\n  text-align: center;\n  max-width: 37.5rem; /* 600px in rem */\n  width: 100%;\n  animation: fadeIn 0.6s ease-in-out;\n}\n\n/* Success Title */\n.success-title {\n  font-size: 2.5rem;\n  margin-bottom: 1.25rem;\n  color: var(--clr-primary-5);\n  font-weight: bold;\n}\n\n/* Success Message */\n.success-message {\n  font-size: 1.3rem;\n  color: var(--clr-primary-3);\n  margin-bottom: 1.25rem;\n}\n\n/* Success Redirect Message */\n.success-redirect {\n  font-size: 1.1rem;\n  color: var(--clr-primary-2);\n}\n\n/* Fade-in Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.role-selection-container {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 2rem;\n  border: 2px solid #ccc;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  background-color: hsl(185, 62%, 45%);\n}\n\n.role-selection-title {\n  text-align: center;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.role-selection-option {\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n}\n\n.role-label {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  color: #444;\n}\n\n.role-input {\n  margin-right: 1rem;\n  transform: scale(1.2);\n  accent-color: #007bff;\n}\n\n.role-selection-button {\n  display: block;\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1.1rem;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.role-selection-button:hover {\n  background-color: #0056b3;\n}\n\n\n/* Open Modal on the Static Page */\n\n\n.account-popup-area {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  /* background: rgba(20, 31, 114, 0.6); */\n  background:  hsl(185, 94%, 87%, 0.6);\n  opacity: 1;\n  z-index: 99;\n  overflow-y: scroll;\n}\n.account-popup-check {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  z-index: 99;\n  margin-top: -300px;\n}\n.account-popup {\n  position: relative;\n  float: left;\n  width: 460px;\n  background: #fff;\n  z-index: 1;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  left: 50%;\n  margin-left: -230px;\n  margin-top: 140px;\n  margin-bottom: 60px;\n  text-align: justify;\n  padding: 40px 60px;\n}\n.account-popup > h3 {\n  float: left;\n  width: 100%;\n  font-family: Quicksand;\n  color: #222;\n  font-weight: bold;\n  margin: 0;\n  margin-bottom: 0px;\n  margin-bottom: 12px;\n  line-height: 10px;\n  text-align: center;\n}\n.account-popup > span {\n  float: left;\n  width: 100%;\n  font-size: 13px;\n  font-family: Open Sans;\n  font-size: 13px;\n  color: #888;\n  margin-top: 20px;\n}\n.account-popup > form {\n  float: left;\n  width: 100%;\n  margin-top: 30px;\n}\n.account-popup > form .cfield {\n  float: left;\n  width: 100%;\n  position: relative;\n  margin-bottom: 19px;\n  border: 2px solid #e8ecec;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n}\n.account-popup > form .cfield input {\n  float: left;\n  width: 100%;\n  background: no-repeat;\n  margin: 0;\n  font-family: Open Sans;\n  font-size: 13px;\n  color: #474747;\n  padding: 16px 45px 16px 15px;\n}\n.account-popup > form .cfield i {\n  position: absolute;\n  right: 0;\n  top: 15px;\n  right: 20px;\n  font-size: 19px;\n}\n.account-popup > form > a {\n  float: right;\n  font-family: Open Sans;\n  font-size: 13px;\n  text-decoration: underline;\n  line-height: 30px;\n}\n.account-popup > form button {\n  float: left;\n  width: 100%;\n  height: 60px;\n  font-size: 17px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  margin-top: 20px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  -webkit-transition: all 0.4s ease 0s;\n  -moz-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  -o-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.account-popup > form button:hover {\n  background: hsl(184, 77%, 34%);\n}\n.account-popup .close-popup {\n  position: absolute;\n  top: -20px;\n  width: 50px;\n  height: 50px;\n  float: none;\n  margin: 0;\n  right: -20px;\n  text-align: center;\n  line-height: 50px;\n  color: #fff;\n  font-size: 20px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.account-popup-register {\n  margin-top: 70px;\n}\n\ntextarea {\n\twidth: 100%;\n\tpadding: 0.375rem 0.75rem;\n\tborder-radius: var(--borderRadius);\n\tbackground: var(--backgroundColor);\n\tborder: 1px solid var(--grey-200);\n}\n\n/*\n=============== \nFAQ's\n===============\n*/\n\nmain {\n  min-height: 100vh;\n  /* using flex because of better browser support */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container {\n  width: 90vw;\n  margin: 5rem auto;\n  background: var(--white);\n  border-radius: var(--borderRadius);\n  padding: 2.5rem;\n  max-width: 800px;\n  box-shadow: var(--shadow-3);\n}\n.container h1 {\n  text-align: center;\n  margin-bottom: 3rem;\n  color: var(--grey-700);\n}\n.question {\n  padding: 1rem 1.5rem;\n  border: 2px solid var(--grey-200);\n  margin-bottom: 1rem;\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-3);\n  margin-bottom: 2rem;\n}\n\n.question p {\n  color: var(--grey-500);\n  line-height: 2;\n  margin-top: 1rem;\n}\n.question header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.question h5 {\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--grey-700);\n}\n.question-btn {\n  background: transparent;\n  border-color: transparent;\n  width: 2rem;\n  height: 2rem;\n  background: var(--primary-900);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: var(--white);\n  cursor: pointer;\n  /* optional - last item */\n  align-self: flex-start;\n  min-width: 2rem;\n}\n\n/*\n=============== \nForm and its corresponding components\n===============\n*/\n\n.form {\n  width: 90vw;\n  max-width: var(--fixed-width);\n  background: var(--white);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2);\n  padding: 2rem 2.5rem;\n  margin: 3rem auto;\n}\n.form-label {\n  display: block;\n  font-size: var(--small-text);\n  margin-bottom: 0.5rem;\n  text-transform: capitalize;\n  letter-spacing: var(--letterSpacing);\n}\n\n.form-input,\n.form-textarea {\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--borderRadius);\n  background: var(--backgroundColor);\n  border: 1px solid var(--grey-200);\n}\n\n.form-row {\n  margin-bottom: 1rem;\n}\n\n.form-textarea {\n  height: 7rem;\n}\n::placeholder {\n  font-family: inherit;\n  color: var(--grey-400);\n}\n.form-alert {\n  color: var(--red-dark);\n  letter-spacing: var(--letterSpacing);\n  text-transform: capitalize;\n}\n/* extra styles */\n.form .form-label {\n  text-align: left;\n}\n.form .btn-block {\n  margin-top: 0.5rem;\n}\n\n\n/*\n=============== \nContact-Hero\n===============\n*/\n\n.contact-hero {\n  min-height: 80vh;\n  background: var(--clr-primary-10);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* underline added to globals */\n.contact-hero .underline {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n.contact-hero-img {\n  display: none;\n}\n/* .hero {\n  background: var(--clr-primary-10);\n} */\n\n.contact-hero-banner {\n  text-align: center;\n  color: var(--clr-white);\n  /* color: darkblue; */\n  padding: 0 3rem;\n}\n.contact-hero-banner h1 {\n  text-transform: uppercase;\n}\n.contact-hero-banner p {\n  max-width: 35rem;\n  margin-left: auto;\n  margin-right: auto;\n  color: var(--clr-white);\n  letter-spacing: var(--spacing);\n}\n.contact-hero-btn {\n  padding: 0.9rem 1.6rem;\n  font-size: 1.25rem;\n  background: var(--clr-white);\n  color: var(--clr-primary-5);\n}\n.contact-hero-btn:hover {\n  background: transparent;\n  color: var(--clr-white);\n  border-color: var(--clr-white);\n}\n.contact-hero {\n  background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),\n    url('../../../src/assets/images/contact_landing_one.jpeg') center/cover no-repeat;\n}\n\n@media screen and (min-width: 768px) {\n  .contact-hero {\n    background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),\n      url('../../../src/assets/images/contact_landing_one.jpeg') center/cover no-repeat;\n  }\n  .contact-hero-banner {\n    padding: 0;\n  }\n  .contact-hero-banner p {\n    max-width: 45rem;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .contact-hero-img {\n    display: block;\n    position: relative;\n  }\n  .contact-hero-center {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .contact-hero-img::before,\n  .about-img::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 0.25rem solid var(--clr-primary-5);\n    top: 2rem;\n    right: -2rem;\n    border-radius: var(--radius);\n  }\n}\n\n\n/*\n=============== \nAbout US - New Design\n===============\n*/\n\n\n.about-us {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n/* .about-page {\n  padding: 4rem 2rem;\n  background-color: var(--clr-primary-9); \n} */\n\n.objectives-section, .disciplines-section, .why-choose-us-section {\n  margin-bottom: 4rem;\n}\n\n.objectives-container, .disciplines-container, .why-choose-us-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2rem;\n  max-width: var(--max-width);\n  margin: 0 auto;\n}\n\n.objectives-content,.vision-mission-content, .disciplines-content, .why-choose-us-content {\n  flex: 1;\n  max-width: 50%;\n  color: var(--clr-grey-1);\n}\n\n.objectives-content h2,.vision-mission-content h2, .disciplines-content h2, .why-choose-us-content h2 {\n  color: var(--clr-primary-1);\n  font-family: var(--ff-primary);\n  margin-bottom: 1.5rem;\n  font-size: 2.5rem;\n}\n\n.objectives-content ul,.vision-mission-content ul, .disciplines-content ul, .why-choose-us-content ul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.objectives-content li,.vision-mission-content li, .disciplines-content li, .why-choose-us-content li {\n  margin-bottom: 1.5rem;\n  /* font-size: 1.125rem; */\n  line-height: 1.6;\n  color: var(--clr-grey-2);\n}\n\n.objectives-content .objective-title, .vision-mission-content .vision-mission-title, .disciplines-content .discipline-title, .why-choose-us-content .why-title {\n  font-weight: bold;\n  color: var(--clr-primary-2);\n  margin-right: 0.4rem;\n}\n\n.objectives-image, .disciplines-image, .why-choose-us-image {\n  flex: 1;\n  max-width: 40%;\n}\n\n.objectives-image img, .disciplines-image img, .why-choose-us-image img {\n  width: 100%;\n  border-radius: var(--radius);\n  box-shadow: var(--light-shadow);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .objectives-container, .disciplines-container, .why-choose-us-container {\n    flex-direction: column;\n  }\n\n  .objectives-content, .vision-mission-content, .disciplines-content, .why-choose-us-content,\n  .objectives-image, .disciplines-image, .why-choose-us-image {\n    max-width: 100%;\n  }\n\n  .objectives-content h2,.vision-mission-content h2, .disciplines-content h2, .why-choose-us-content h2 {\n    font-size: 2rem;\n  }\n\n  .objectives-content li, .vision-mission-content li, .disciplines-content li, .why-choose-us-content li {\n    font-size: 1rem;\n  }\n}\n.about-section, .vision-mission-section, .objectives-section, .disciplines-section {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 3rem;\n}\n\n.about-content, .vision-mission-content, .objectives-content, .disciplines-content {\n  flex: 1;\n  padding: 1rem;\n  color: var(--clr-grey-1);\n}\n\n.about-image, .vision-mission-image, .objectives-image, .disciplines-image , .why-choose-us-image{\n  flex: 1;\n  padding: 1rem;\n  /* background: linear-gradient(rgb(44, 174, 186, 0.7), rgba(0, 0, 0, 0.7)),\n    url('../../../src/assets/images/contact_landing_one.jpeg') center/cover no-repeat; */\n}\n\n.about-image img, .vision-mission-image img, .objectives-image img, .disciplines-image img , .why-choose-us-image img{\n  width: 100%;\n  height: auto;\n  border-radius: var(--radius);\n  box-shadow: var(--light-shadow);\n}\n\n.about-content h2, .vision-mission-content h2, .objectives-content h2, .disciplines-content h2 , .why-choose-us-content h2{\n  color: var(--clr-primary-5);\n  margin-bottom: 1rem;\n  font-family: var(--ff-primary);\n}\n\n.about-content p, .vision-mission-content p, .objectives-content p, .disciplines-content p , .why-choose-us-content p{\n  color: var(--clr-grey-2);\n  font-family: var(--ff-secondary);\n}\n\n\n.about-section .about-content,\n.objectives-section .objectives-content\n\n{\n  order: 1;\n}\n\n.about-section .about-image, \n.objectives-section .objectives-image \n\n{\n  order: 2;\n}\n\n.vision-mission-section .vision-mission-content, .disciplines-section .disciplines-content {\n  order: 2;\n}\n\n.vision-mission-section .vision-mission-image, .disciplines-section .disciplines-image {\n  order: 1;\n}\n\n/* ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n  color: var(--clr-grey-5);\n} */\n\np {\n  font-family: var(--ff-secondary);\n  line-height: 1.8;\n  color: var(--clr-grey-5);\n}\n\n@media screen and (max-width: 768px) {\n  .about-section, .vision-mission-section, .objectives-section, .disciplines-section {\n    flex-direction: column;\n  }\n}\n\n.vision-mission-image, .objectives-image, .disciplines-image , .why-choose-us-image  {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  background-color: var(--clr-primary-10); \n}\n\n.about-main-photo {\n  width: 100%;\n  max-width: 600px;\n  border: 5px solid var(--clr-primary-5);\n  border-radius: 20px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  object-fit: cover;\n}\n\n.about-main-photo:hover {\n  transform: scale(1.05);\n  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);\n}\n\n\n/*\n=============== \nAbout-Hero\n===============\n*/\n\n.about-hero {\n  min-height: 80vh;\n  background: var(--clr-primary-10);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* underline added to globals */\n.about-hero .underline {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n.about-hero-img {\n  display: none;\n}\n/* .hero {\n  background: var(--clr-primary-10);\n} */\n\n.about-hero-banner {\n  text-align: center;\n  color: var(--clr-white);\n  /* color: darkblue; */\n  padding: 0 3rem;\n}\n.about-hero-banner h1 {\n  text-transform: uppercase;\n}\n.about-hero-banner p {\n  max-width: 35rem;\n  margin-left: auto;\n  margin-right: auto;\n  color: var(--clr-white);\n  letter-spacing: var(--spacing);\n}\n.about-hero-btn {\n  padding: 0.9rem 1.6rem;\n  font-size: 1.25rem;\n  background: var(--clr-white);\n  color: var(--clr-primary-5);\n}\n.about-hero-btn:hover {\n  background: transparent;\n  color: var(--clr-white);\n  border-color: var(--clr-white);\n}\n.about-hero {\n  background: linear-gradient(rgb(45, 70, 70, 0.7), rgba(0, 0, 0, 0.7)),\n    url('../../../src/assets/images/about_banner_two.jpeg') center/cover no-repeat\n}\n\n@media screen and (min-width: 768px) {\n  .about-hero {\n    background: linear-gradient(rgb(45, 70, 70, 0.7), rgba(0, 0, 0, 0.7)),\n    url('../../../src/assets/images/about_banner_two.jpeg') center/cover no-repeat\n  }\n  .about-hero-banner {\n    padding: 0;\n  }\n  .about-hero-banner p {\n    max-width: 60rem;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .about-hero-img {\n    display: block;\n    position: relative;\n  }\n  .about-hero-center {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .about-hero-img::before,\n  .about-img::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 0.25rem solid var(--clr-primary-5);\n    top: 2rem;\n    right: -2rem;\n    border-radius: var(--radius);\n  }\n}\n\n/*\n=============== \nSection Divider line\n===============\n*/\n.section-divider {\n  border: none;\n  border-top: 2px solid var(--red-dark); /* Light grey line */\n  margin: 2rem 0; /* Space around the line */\n  opacity: 0.8; /* Slight transparency */\n}\n\n/* Optional: You can animate the separator when it comes into view */\n@keyframes fadeInLine {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n.section-divider {\n  animation: fadeInLine 0.6s ease-in-out;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
